import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const datesShortCuts = [
  {
    label: 'Última semana',
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
  },
  {
    label: 'Últimos 15 días',
    startDate: new Date(new Date().setDate(new Date().getDate() - 15)),
    endDate: new Date(),
  },
  {
    label: 'Último mes',
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date(),
  },
  {
    label: 'Últimos 3 meses',
    startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
    endDate: new Date(),
  },
  {
    label: 'Últimos 6 meses',
    startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
    endDate: new Date(),
  },
  {
    label: 'Último año',
    startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
    endDate: new Date(),
  },
];

export const futureDatesShortCuts = [
  {
    label: 'Previo a hoy día',
    startDate: null,
    endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
  },
  {
    label: 'Hasta hoy día',
    startDate: null,
    endDate: new Date(),
  },
  {
    label: 'Solo hoy día',
    startDate: new Date(),
    endDate: new Date(),
  },
  {
    label: 'De hoy día a fin de la semana',
    startDate: new Date(),
    endDate: dayjs().endOf('week').utc().toDate(),
  },
  {
    label: 'De hoy día a 15 días',
    startDate: new Date(),
    endDate: new Date(new Date().setDate(new Date().getDate() + 15)),
  },
  {
    label: 'De hoy día a 30 días',
    startDate: new Date(),
    endDate: new Date(new Date().setDate(new Date().getDate() + 30)),
  },
  {
    label: 'De hoy día a 60 días',
    startDate: new Date(),
    endDate: new Date(new Date().setDate(new Date().getDate() + 60)),
  },
];

export const dateShortcutsByType = {
  request: datesShortCuts,
  payment: datesShortCuts,
  created: datesShortCuts,
  activation: datesShortCuts,
  due: datesShortCuts,
};
